import { Injectable, Inject } from "@angular/core";
import { Observable } from "rxjs";
import { IQueryInvoker, QUERY_INVOKER, Tlob } from "@ebootis/common";

@Injectable({providedIn: 'root'})
export class UserInfos
{
	constructor(@Inject(QUERY_INVOKER) private m_queryInvoker: IQueryInvoker) { }
	query(): Observable<UserInfos.Result>
	{
		return this.m_queryInvoker.doQuery("UserInfos", null);
	}
};

export namespace UserInfos
{
	export interface Result
	{
		oid?: string;
		costCenter?: string;
		firstName?: string;
		lastName?: string;
		email?: string;
		phone?: string;
		address?: Address;
	};
	export interface Address
	{
		oid?: string;
		alternateName?: string;
		street?: string;
		zip?: string;
		city?: string;
		countryIso?: string;
	};
};
